export const debounce = (func, timeout = 1000) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const customStylesForGrid = {
  headCells: {
    style: {
      padding: "6px",
      fontSize: "16px",
      fontWeight: 700,
    },
  },
  cells: {
    style: {
      color: "#212529",
      padding: "6px",
      fontSize: "16px",
    },
  },
  pagination: {
    style: {
      fontSize: "16px",
      color: "#212529",
    },
  },
  rows: {
    style: {
      borderBottom: '0.1px solid var(--custom-border-color) !important', 
      minHeight: 'unset !important'
    },
  },
};
